<template>
  <!--
    作者：kmdshop
    时间：2023-05-07
    描述：插件中心-循环返利
  -->
  <div>
    <!--商品设置-->
    <Product v-if="activeName == 'product'"></Product>
    <!-- <Record v-if="activeName == 'record'"></Record> -->

    <!--兑换设置-->
    <Settings v-if="activeName == 'settings'"></Settings>


  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Product from './index/index';
import Settings from './setting';
// import Record from './record';


export default {
  components: {
    Product,
    Settings,
    // Record
  },
  data() {
    return {
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'record',
      /*切换数组原始数据*/
      sourceList: [
      // {
      //     key: 'record',
      //     value: '记录',
      //     path:'/plus/looprebate/record'
      //   },
        {
          key: 'product',
          value: '奖励设置',
          path:'/plus/team/index/index'
        },
      
        {
          key: 'settings',
          value: '基础设置',
          path:'/plus/team/setting'
        },
       
      ],
      /*权限筛选后的数据*/
      tabList:[],
    };
  },
  created() {

    this.tabList=this.authFilter();
    
    if(this.tabList.length>0){
      this.activeName=this.tabList[0].key;
    }

    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }

    /*监听传插件的值*/
    bus.$on('activeValue', res => {
      this.activeName = res;
    });

    //发送类别切换
    let params = {
      active: this.activeName,
      list: this.tabList,
      tab_type: 'loop_rebate'
    };
    bus.$emit('tabData', params);
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type: 'loop_rebate', list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/team/index.vue